import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { LatestEpisode } from "@/components/site/LatestEpisode";
import { EpisodeCanon } from "@/components/site/EpisodeCanon";
import { NextWeek } from "@/components/site/NextWeek";
import { Feed } from "@/components/site/Feed";
import { Letters } from "@/components/site/Letters";
import { AboutHost } from "@/components/site/AboutHost";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  const [episodes, setEpisodes] = useState([]);
  const [dispatches, setDispatches] = useState([]);
  const [letters, setLetters] = useState([]);
  const [site, setSite] = useState(null);

  const loadLetters = useCallback(async () => {
    try {
      const { data } = await api.get("/letters");
      setLetters(data);
    } catch {
      /* section shows its own empty state */
    }
  }, []);

  const loadSite = useCallback(async () => {
    try {
      const { data } = await api.get("/site");
      setSite(data);
    } catch {
      /* teaser falls back to defaults */
    }
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const [epRes, disRes, ttRes, ytRes] = await Promise.all([
          api.get("/episodes"),
          api.get("/dispatches"),
          api.get("/tiktok/videos"),
          api.get("/youtube/videos"),
        ]);
        setEpisodes(epRes.data);
        const youtubeId = (url) => {
          const match = (url || "").match(/(?:youtu\.be\/|[?&]v=)([\w-]{11})/);
          return match ? match[1] : null;
        };
        const manualIds = new Set(
          disRes.data.map((d) => youtubeId(d.link_url)).filter(Boolean)
        );
        const ytCards = ytRes.data.filter((v) => !manualIds.has(youtubeId(v.link_url)));
        const merged = [...disRes.data, ...ttRes.data, ...ytCards].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setDispatches(merged);
      } catch {
        /* sections render with empty states */
      }
      loadSite();
      loadLetters();
    };
    load();
  }, [loadLetters, loadSite]);

  const latest = episodes.find((ep) => ep.status === "latest");

  return (
    <main data-testid="home-page">
      <Header />
      <Hero />
      <LatestEpisode episode={latest} />
      <EpisodeCanon episodes={episodes} />
      <NextWeek site={site} onSiteRefresh={loadSite} />
      <Feed posts={dispatches} />
      <Letters letters={letters} onLetterSent={loadLetters} />
      <AboutHost />
      <Footer site={site} />
    </main>
  );
}
